import React from 'react';
import { Button } from '@shared/components';
import { formatDateOnlyShort } from '@/app/utils/formatDate';

interface SmriqPlanControlsSummaryProps {
    className?: string;
    durationMonths?: number;
    includeMotTests?: boolean;
    planStartDate?: string;
    onEdit: () => void;
}

/** Stands in for SmriqPlanControls once a plan is generated: a one-line recap of the parameters
 *  it was generated with (smaller than the title), plus an Edit affordance to change them. The
 *  regenerate loader lives in SmriqSchedulePanel, so this never shows one of its own. */
export const SmriqPlanControlsSummary: React.FC<SmriqPlanControlsSummaryProps> = ({
    className,
    durationMonths,
    includeMotTests,
    planStartDate,
    onEdit,
}) => {
    const recap = [
        planStartDate ? `Starts ${formatDateOnlyShort(planStartDate)}` : null,
        durationMonths !== undefined ? `${durationMonths} months` : null,
        includeMotTests === undefined ? null : includeMotTests ? 'MOT included' : 'MOT excluded',
    ]
        .filter(Boolean)
        .join(' · ');

    return (
        <div
            className={`bg-mp-surface rounded-xl flex items-center justify-between gap-4 ${className ?? ''}`}
        >
            <div className="flex flex-wrap items-baseline gap-x-2">
                <h3 className="text-base font-semibold text-mp-foreground">Service Plan Parameters</h3>
                {recap && <span className="text-xs text-mp-muted">{recap}</span>}
            </div>
            <Button type="button" size="sm" variant="outline" onClick={onEdit}>
                Edit plan
            </Button>
        </div>
    );
};
